/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module ForagerTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

/**
 * The data in specified format.
 *
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "Data".
 */
export type Data = string;
/**
 * Fully-quantified path to file
 *
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "Path".
 */
export type Path = string;

export interface Forager {
    [k: string]: any;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "CopyConfigTemplateParameters".
 */
export interface CopyConfigTemplateParameters {
    /**
     * Full path to output directory where the new template files will be copied.
     */
    outputDirectory?: string;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "ExtractFramesParameters".
 */
export interface ExtractFramesParameters {
    /**
     * Full path to media file from which to extract frames
     */
    filename?: string;
    /**
     * Full path to output directory where iFrames will be output in name format of iframe-###.png
     */
    outputDirectory?: string;
    options?: {
        /**
         * If true, will output only iframes (key frames).
         */
        iFrames?: boolean;
    };
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "GetAppInfoReturn".
 */
export interface GetAppInfoReturn {
    /**
     * The complete path to the application log file
     */
    logfile: string;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "LaunchWithNativeAppParameters".
 */
export interface LaunchWithNativeAppParameters {
    file: Path;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "ReadWorkspaceParameters".
 */
export interface ReadWorkspaceParameters {
    /**
     * Complete path to the workspace file to load. If empty will load the default (as specified in the user setting.s
     */
    filename?: string;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "ReadWorkspaceReturn".
 */
export interface ReadWorkspaceReturn {
    /**
     * Contents of read JSON workspace file
     */
    workspace?: string;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "ReadFileParameters".
 */
export interface ReadFileParameters {
    format: Format;
    path: Path;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "ReadFileReturn".
 */
export interface ReadFileReturn {
    data: Data;
    format: Format;
    path: Path;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "SaveWorkspaceParameters".
 */
export interface SaveWorkspaceParameters {
    /**
     * Complete path to where to save the workspace file.  If empty will save to the default workspace (as specified in the user settings.
     */
    filename?: string;
    /**
     * Contents of JSON workspace file to write.
     */
    workspace?: string;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "TrimVideoParameters".
 */
export interface TrimVideoParameters {
    /**
     * Complete path to source video file trim.
     */
    input?: string;
    /**
     * Complete path to name of trimmed output file to be created.
     */
    output?: string;
    /**
     * Time in seconds into file to trim away.
     */
    start?: number;
    /**
     * Time in seconds into file to stop trimming.
     */
    end?: number;
}
/**
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "WriteFileParameters".
 */
export interface WriteFileParameters {
    data: Data;
    format: Format;
    path: Path;
}

/**
 * The format in of the data.  Either either 'base64' (for binary data) or 'text'.
 *
 * This interface was referenced by `Forager`'s JSON-Schema
 * via the `definition` "Format".
 */
export enum Format {
    text = 'text',
    base64 = 'base64'
}


}
